import { Suspense } from 'react';
import { RouterProvider } from 'react-router/dom';
import { router } from './router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AppProvider } from '@contexts/app';
import { WebsocketProvider } from '@contexts/websocket';

export const App = () => {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <AppProvider>
        <WebsocketProvider>
          <Suspense>
            <RouterProvider router={router} />
          </Suspense>
          <ReactQueryDevtools initialIsOpen={false} />
        </WebsocketProvider>
      </AppProvider>
    </QueryClientProvider>
  );
};
